(function () {

  'use strict';


  /* =====================================================
     KOTHAR PRODUCT OBJECT
  ===================================================== */

  window.KotharProduct =
    window.KotharProduct || {};


  /* =====================================================
     SHOPIFY ROOT
  ===================================================== */

  function shopifyRoot() {

    if (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) {

      return Shopify.routes.root;

    }

    return '/';

  }


  /* =====================================================
     MONEY
  ===================================================== */

  function formatMoney(cents) {

    cents =
      Number(cents || 0);


    return new Intl.NumberFormat(
      'en-IN',
      {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
      }
    ).format(
      cents / 100
    );

  }


  /* =====================================================
     OPEN CART MODAL
  ===================================================== */

  function openModal(data) {

    var modal =
      document.getElementById(
        'kothar-cart-modal'
      );


    /*
      Modal is optional.
      Do not throw an error if the modal
      is not present on a page.
    */

    if (!modal) {

      return;

    }


    var name =
      document.getElementById(
        'kothar-modal-product-name'
      );


    var variant =
      document.getElementById(
        'kothar-modal-variant'
      );


    var price =
      document.getElementById(
        'kothar-modal-price'
      );


    var image =
      document.getElementById(
        'kothar-modal-image'
      );


    /* =================================================
       DETAILS LINK
    ================================================= */

    var detailsLink =
      document.getElementById(
        'kothar-modal-details'
      );


    if (detailsLink) {

      if (data.url) {

        detailsLink.href =
          data.url;

        detailsLink.style.display =
          'flex';

      } else {

        detailsLink.href =
          '#';

        detailsLink.style.display =
          'none';

      }

    }


    /* =================================================
       PRODUCT NAME
    ================================================= */

    if (name) {

      name.textContent =
        data.name ||
        'Product';

    }


    /* =================================================
       VARIANT
    ================================================= */

    if (variant) {

      variant.textContent =
        data.variant ||
        '';

    }


    /* =================================================
       PRICE
    ================================================= */

    if (price) {

      price.textContent =
        formatMoney(
          data.price
        );

    }


    /* =================================================
       IMAGE
    ================================================= */

    if (image) {

      if (data.image) {

        image.src =
          data.image;

        image.alt =
          data.name ||
          'Product';

        image.style.display =
          'block';

      } else {

        image.removeAttribute(
          'src'
        );

        image.style.display =
          'none';

      }

    }


    /* =================================================
       OPEN
    ================================================= */

    modal.classList.add(
      'is-open'
    );


    modal.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'kothar-modal-open'
    );

  }


  /* =====================================================
     CLOSE MODAL
  ===================================================== */

  function closeModal() {

    var modal =
      document.getElementById(
        'kothar-cart-modal'
      );


    if (!modal) {

      return;

    }


    modal.classList.remove(
      'is-open'
    );


    modal.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'kothar-modal-open'
    );

  }


  window.KotharProduct.openModal =
    openModal;


  window.KotharProduct.closeModal =
    closeModal;



  /* =====================================================
     UPDATE PRODUCT CARD VARIANT
  ===================================================== */

  function updateVariant(select) {

    var card =
      select.closest(
        '.product-card'
      );


    if (!card) {

      return;

    }


    var option =
      select.options[
        select.selectedIndex
      ];


    if (!option) {

      return;

    }


    var price =
      Number(
        option.dataset.price ||
        0
      );


    var compare =
      Number(
        option.dataset.compare ||
        option.dataset.mrp ||
        0
      );


    var available =
      option.dataset.available ===
      'true';


    /* =================================================
       PRICE
    ================================================= */

    var priceDisplay =
      card.querySelector(
        '.price-display'
      );


    if (priceDisplay) {

      var amount =
        priceDisplay.querySelector(
          '.amt'
        );


      var mrp =
        priceDisplay.querySelector(
          '.mrp'
        );


      var save =
        priceDisplay.querySelector(
          '.save'
        );


      if (amount) {

        amount.textContent =
          formatMoney(
            price
          );

      }


      if (mrp) {

        mrp.textContent =
          compare > price
            ? formatMoney(
                compare
              )
            : '';

      }


      if (save) {

        save.textContent =
          compare > price
            ? 'Save ' +
              formatMoney(
                compare - price
              )
            : '';

      }

    }


    /* =================================================
       PRODUCT CARD BUTTON
    ================================================= */

    var button =
      card.querySelector(
        '.btn-add-cart'
      );


    if (button) {

      button.disabled =
        !available;


      if (available) {

        button.classList.remove(
          'is-sold-out'
        );

      } else {

        button.classList.add(
          'is-sold-out'
        );

      }

    }

  }


  window.KotharProduct.updateVariant =
    updateVariant;



  /* =====================================================
     ADD TO CART
  ===================================================== */

  function addToCart(button) {

    var card =
      button.closest(
        '.product-card'
      );


    if (!card) {

      console.error(
        'Kothar: product-card not found'
      );

      return;

    }


    /* =================================================
       VARIANT SELECT
    ================================================= */

    var selector =
      card.querySelector(
        '.weight-select'
      );


    if (!selector) {

      console.error(
        'Kothar: weight-select not found'
      );

      return;

    }


    var option =
      selector.options[
        selector.selectedIndex
      ];


    if (!option) {

      return;

    }


    var variantId =
      selector.value;


    if (!variantId) {

      console.error(
        'Kothar: Shopify variant ID missing'
      );

      return;

    }


    /* =================================================
       AVAILABILITY
    ================================================= */

    var available =
      option.dataset.available ===
      'true';


    if (!available) {

      return;

    }


    /* =================================================
       PRODUCT NAME
    ================================================= */

    var productName =
      card.dataset.name ||
      'Product';


    /* =================================================
       VARIANT NAME
    ================================================= */

    var variantName =
      option.textContent
        .replace(
          '— Sold out',
          ''
        )
        .trim();


    /* =================================================
       PRICE
    ================================================= */

    var price =
      Number(
        option.dataset.price ||
        0
      );


    /* =================================================
       IMAGE
    ================================================= */

    var image =
      card.querySelector(
        '.art img'
      );


    var imageUrl =
      '';


    if (image) {

      imageUrl =
        image.currentSrc ||
        image.src ||
        '';

    }


    if (!imageUrl) {

      imageUrl =
        card.dataset.image ||
        '';

    }


    /* =================================================
       PRODUCT URL
    ================================================= */

    var productUrl =
      card.dataset.url ||
      '';


    if (!productUrl) {

      var productLink =
        card.querySelector(
          '.art a[href], .body h3 a[href]'
        );


      if (
        productLink &&
        productLink.href
      ) {

        productUrl =
          productLink.href;

      }

    }


    /* =================================================
       BUTTON LOADING
    ================================================= */

    var oldHTML =
      button.innerHTML;


    button.disabled =
      true;


    var text =
      button.querySelector(
        '.add-cart-text'
      );


    if (text) {

      text.textContent =
        'Adding...';

    } else {

      button.textContent =
        'Adding...';

    }


    /* =================================================
       SHOPIFY CART ADD
    ================================================= */

    fetch(
      shopifyRoot() +
      'cart/add.js',
      {

        method: 'POST',

        headers: {

          'Content-Type':
            'application/json',

          'Accept':
            'application/json'

        },

        body: JSON.stringify({

          items: [

            {

              id:
                Number(
                  variantId
                ),

              quantity:
                1

            }

          ]

        })

      }

    )


    /* =================================================
       RESPONSE
    ================================================= */

    .then(
      function (response) {

        if (!response.ok) {

          return response
            .json()
            .then(
              function (error) {

                throw error;

              }
            );

        }


        return response.json();

      }
    )


    /* =================================================
       UPDATED CART
    ================================================= */

    .then(
      function () {

        return fetch(
          shopifyRoot() +
          'cart.js'
        );

      }
    )


    .then(
      function (response) {

        return response.json();

      }
    )


    /* =================================================
       SUCCESS
    ================================================= */

    .then(
      function (cart) {


        /* =============================================
           CART COUNT
        ============================================== */

        document
          .querySelectorAll(
            '[data-cart-count], .cart-count, .cart-item-count'
          )
          .forEach(
            function (element) {

              element.textContent =
                cart.item_count;

            }
          );


        /* =============================================
           MODAL
        ============================================== */

        openModal({

          name:
            productName,

          variant:
            variantName,

          price:
            price,

          image:
            imageUrl,

          url:
            productUrl

        });


        /* =============================================
           EVENTS
        ============================================== */

        document.dispatchEvent(
          new CustomEvent(
            'kothar:cart-added',
            {
              detail:
                cart
            }
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            'cart:updated'
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh'
          )
        );


        /* =============================================
           RESET
        ============================================== */

        setTimeout(
          function () {

            button.innerHTML =
              oldHTML;

            button.disabled =
              false;

          },
          1200
        );

      }
    )


    /* =================================================
       ERROR
    ================================================= */

    .catch(
      function (error) {

        console.error(
          'Kothar Add to Cart Error:',
          error
        );


        button.innerHTML =
          'Try Again';


        setTimeout(
          function () {

            button.innerHTML =
              oldHTML;

            button.disabled =
              false;

          },
          1500
        );

      }
    );

  }


  window.KotharProduct.addToCart =
    addToCart;


  window.addToCart =
    addToCart;



  /* =====================================================
     PRODUCT DETAILS — ADD TO BOX
     
     THIS IS THE IMPORTANT FIX
  ===================================================== */

  function syncProductDetailsButton() {

    var button =
      document.getElementById(
        'pdpAddToCart-product-details-section'
      );


    var buttonText =
      document.getElementById(
        'pdpBtnText-product-details-section'
      );


    var buttonTotal =
      document.getElementById(
        'pdpBtnTotal-product-details-section'
      );


    if (!button) {

      return;

    }


    /* =================================================
       FIND SELECTED VARIANT
    ================================================= */

    var selectedVariant =
      document.querySelector(
        '.size-opt.selected'
      );


    /* =================================================
       NO SIZE BUTTON
    ================================================= */

    if (!selectedVariant) {

      /*
        Try to find another variant source.
      */

      var currentAvailable =
        document.querySelector(
          '.size-opt:not([disabled])'
        );


      if (currentAvailable) {

        selectedVariant =
          currentAvailable;

      }

    }


    /* =================================================
       NO VARIANT
    ================================================= */

    if (!selectedVariant) {

      button.disabled =
        true;


      button.classList.add(
        'is-sold-out'
      );


      if (buttonText) {

        buttonText.textContent =
          'Sold out';

      }


      if (buttonTotal) {

        buttonTotal.textContent =
          '';

      }


      return;

    }


    /* =================================================
       CHECK AVAILABILITY
    ================================================= */

    var isUnavailable =
      selectedVariant.disabled ||
      selectedVariant.classList.contains(
        'sold-out'
      );


    /* =================================================
       AVAILABLE
    ================================================= */

    if (!isUnavailable) {

      button.disabled =
        false;


      button.removeAttribute(
        'disabled'
      );


      button.classList.remove(
        'is-sold-out'
      );


      button.classList.add(
        'is-available'
      );


      if (buttonText) {

        buttonText.textContent =
          'Add to Box';

      }


      /*
        Try to read price from selected variant
      */

      var selectedPrice =
        selectedVariant.querySelector(
          '.so-price'
        );


      if (
        buttonTotal &&
        selectedPrice
      ) {

        buttonTotal.textContent =
          selectedPrice.textContent;

      }


    } else {

      /* =================================================
         SOLD OUT
      ================================================== */

      button.disabled =
        true;


      button.setAttribute(
        'disabled',
        'disabled'
      );


      button.classList.remove(
        'is-available'
      );


      button.classList.add(
        'is-sold-out'
      );


      if (buttonText) {

        buttonText.textContent =
          'Sold out';

      }


      if (buttonTotal) {

        buttonTotal.textContent =
          '';

      }

    }

  }



  /* =====================================================
     SELECT FIRST AVAILABLE PRODUCT VARIANT
     
     This fixes the case where the first variant
     is unavailable but another variant has stock.
  ===================================================== */

  function selectFirstAvailableProductVariant() {

    var selected =
      document.querySelector(
        '.size-opt.selected'
      );


    var available =
      document.querySelector(
        '.size-opt:not([disabled])'
      );


    /*
      If selected variant is unavailable
      and another variant is available,
      automatically select available one.
    */

    if (
      selected &&
      selected.disabled &&
      available
    ) {

      available.click();

      return;

    }


    /*
      If nothing is selected,
      select first available variant.
    */

    if (
      !selected &&
      available
    ) {

      available.click();

    }

  }



  /* =====================================================
     OBSERVE VARIANT CHANGES
  ===================================================== */

  function initProductDetailsWatcher() {

    /*
      Initial sync
    */

    selectFirstAvailableProductVariant();

    syncProductDetailsButton();


    /*
      Watch changes to variant buttons.
      This is useful because renderVariants()
      creates the buttons dynamically.
    */

    var target =
      document.body;


    if (!target) {

      return;

    }


    var observer =
      new MutationObserver(
        function () {

          syncProductDetailsButton();

        }
      );


    observer.observe(
      target,
      {

        subtree: true,

        childList: true,

        attributes: true,

        attributeFilter: [
          'class',
          'disabled'
        ]

      }
    );


    /*
      Periodic fallback.
      Useful when another script changes
      variant state without MutationObserver.
    */

    setInterval(
      function () {

        syncProductDetailsButton();

      },
      500
    );

  }



  /* =====================================================
     PRODUCT DETAIL BUTTON CLICK
     
     Prevent click if sold out.
  ===================================================== */

  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          '#pdpAddToCart-product-details-section'
        );


      if (!button) {

        return;

      }


      if (button.disabled) {

        event.preventDefault();

        event.stopPropagation();

        return;

      }

    },
    true
  );



  /* =====================================================
     MODAL INITIALIZATION
  ===================================================== */

  function initModal() {

    var modal =
      document.getElementById(
        'kothar-cart-modal'
      );


    /*
      Modal is optional.
      Some pages do not contain it.
      Do NOT throw an error.
    */

    if (!modal) {

      return;

    }


    /* =================================================
       CLOSE BUTTONS
    ================================================= */

    modal
      .querySelectorAll(
        '[data-kothar-modal-close]'
      )
      .forEach(
        function (element) {

          element.addEventListener(
            'click',
            closeModal
          );

        }
      );


    /* =================================================
       VIEW DETAILS
    ================================================= */

    var detailsLink =
      modal.querySelector(
        '#kothar-modal-details'
      );


    if (detailsLink) {

      detailsLink.addEventListener(
        'click',
        function (event) {

          var href =
            detailsLink.getAttribute(
              'href'
            );


          if (
            !href ||
            href === '#'
          ) {

            event.preventDefault();

            console.warn(
              'Kothar: Product URL not available'
            );

          }

        }
      );

    }

  }



  /* =====================================================
     ESCAPE CLOSE
  ===================================================== */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape'
      ) {

        closeModal();

      }

    }
  );



  /* =====================================================
     INITIALIZE
  ===================================================== */

  function init() {

    initModal();


    document
      .querySelectorAll(
        '.weight-select'
      )
      .forEach(
        function (select) {

          updateVariant(
            select
          );

        }
      );


    /*
      Product detail button fix
    */

    initProductDetailsWatcher();


    console.log(
      'Kothar Cart System Ready'
    );

  }



  /* =====================================================
     START
  ===================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


})();